
import { Vue, Component, Ref } from 'vue-property-decorator'
import { cloneDeep } from 'lodash-es'
import { FormModel, Checkbox, Radio, Alert } from 'ant-design-vue'
import type { KsExaminationItemDayOutput, KsExaminationItemResultOutput, QuestionAnswer } from '@/api/swagger-exam'

interface IForm {
  examinationId: string
  questionAnswers: Array<QuestionAnswer>
}

export enum QuestionType {
  /**
   * 单选
   */
  Single = 10,
  /**
   * 多选
   */
  Multiple = 20,
  /**
   * 判断
   */
  TrueOfFalse = 30,
}

@Component({
  name: 'DailyExamModal',
  components: {
    'a-form-model': FormModel,
    'a-form-model-item': FormModel.Item,
    'a-checkbox-group': Checkbox.Group,
    'a-checkbox': Checkbox,
    'a-radio-group': Radio.Group,
    'a-radio': Radio,
    'a-alert': Alert,
  },
})
export default class DailyExamModal extends Vue {
  @Ref('ruleForm')
  private ruleForm!: FormModel

  private visible = false
  private submitLoading = false
  private shouldEmitSuccessAfterClose = false

  private defaultForm: IForm = {
    examinationId: '',
    questionAnswers: [],
  }
  private formModel: IForm = cloneDeep(this.defaultForm)

  private detailQuestionList: KsExaminationItemResultOutput[] = []

  private questionList: Array<KsExaminationItemDayOutput> = []

  private prefixIndexs = new Array(26).fill('').map((_, i) => String.fromCharCode(65 + i)) // A-Z
  private questionTypeEnum = QuestionType

  private isExam = true // 是否开始考试
  private isPass = false // 是否通过考试

  private get isAllAnswerCorrect() {
    // return this.detailQuestionList.every((it) => it.isCorrect)
    return this.isPass
  }

  private get isCanClose() {
    return !this.isExam && this.isAllAnswerCorrect
  }

  public async checkAndShow() {
    await this.getQuestionData()
    const hasQuestion = this.questionList.length > 0
    this.visible = hasQuestion
    return hasQuestion
  }

  private getQuestionData() {
    return this.$examHttp
      .get('/api/ksexamination/getdayexaminationlist')
      .then((res) => {
        this.questionList = res?.data || []
        this.formModel.examinationId = this.questionList.find((item) => !!item.examinationId)?.examinationId || ''
      })
      .catch((err) => {
        this.$message.error(err.message || '获取题目失败')
      })
  }

  private submit() {
    if (this.submitLoading) return
    this.ruleForm.validate((valid) => {
      if (!valid) return
      this.submitLoading = true
      this.$examHttp
        .post('/api/ksexamination/submitdayexamination', this.formModel)
        .then((res) => {
          this.$message.success('提交成功')
          this.isExam = false

          const sortIds = this.formModel.questionAnswers.map((it) => it.questionId)
          this.detailQuestionList =
            (res?.data?.ksExaminationItemResultOutputs || []).sort((a, b) => {
              return sortIds.indexOf(a.questionId || '') - sortIds.indexOf(b.questionId || '')
            }) || []
          this.isPass = res?.data?.isPass
          if (this.detailQuestionList.length > 0 && this.isAllAnswerCorrect) {
            this.shouldEmitSuccessAfterClose = true
            this.visible = false
          }
        })
        .catch((err) => {
          this.$message.error(err.message || '提交失败')
          this.$emit('exam-success')
        })
        .finally(() => {
          this.submitLoading = false
        })
    })
  }

  private getAnswer(id: QuestionAnswer['questionId']) {
    if (!id) return
    return this.formModel.questionAnswers.find((item) => item.questionId === id)?.answerContent
  }

  /**
   * 单选题选择
   */
  private changeRadioAnswer(value: string, id: string) {
    if (!value) {
      this.formModel.questionAnswers = this.formModel.questionAnswers.filter((item) => item.questionId !== id)
      return
    }

    const index = this.formModel.questionAnswers.findIndex((item) => item.questionId === id)

    if (index >= 0) {
      this.$set(this.formModel.questionAnswers, index, {
        questionId: id,
        answerContent: value,
      })
    } else {
      this.formModel.questionAnswers.push({
        questionId: id,
        answerContent: value,
      })
    }
  }

  /**
   * 复选题选择
   */
  private changeCheckboxAnswer(values: string[], questionId: string) {
    if (!Array.isArray(values)) return
    if (Array.isArray(values) && !values.length) {
      this.formModel.questionAnswers = this.formModel.questionAnswers.filter((item) => item.questionId !== questionId)
      return
    }

    const index = this.formModel.questionAnswers.findIndex((item) => item.questionId === questionId)
    if (index >= 0) {
      this.$set(this.formModel.questionAnswers, index, {
        questionId: questionId,
        answerContent: values.sort().join(''),
      })
    } else {
      this.formModel.questionAnswers.push({
        questionId: questionId,
        answerContent: values.sort().join(''),
      })
    }
  }

  private afterClose() {
    const shouldEmitSuccessAfterClose = this.shouldEmitSuccessAfterClose
    this.shouldEmitSuccessAfterClose = false
    this.ruleForm?.resetFields()
    this.formModel = cloneDeep(this.defaultForm)
    this.detailQuestionList = []
    this.isExam = true
    if (shouldEmitSuccessAfterClose) {
      this.$emit('exam-success')
    }
  }

  private handleReExam() {
    this.formModel = cloneDeep(this.defaultForm)
    this.isExam = true
    this.getQuestionData()
  }
}
